import Vue from 'vue'
import Router from 'vue-router'
const { routes } = require('./routes.js')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})
